module.exports = __webpack_public_path__ + "static/media/SSI.2447a74c.pdf";